import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    name: '404',
    redirect: { name: 'validator'}
  },
  {
    path: '/',
    name: 'login',
    component: Login,
    beforeEnter: guardLogin

  },
  {
    path: '/validator',
    name: 'validator',
    component: () => import(/* webpackChunkName: "suppliers" */ '../views/Validator.vue'),
    beforeEnter: guardRoute,
  },
]

function guardRoute(to, from, next) {
  const isLoggedIn = store.getters.isLoggedIn
  if (!isLoggedIn) {
    const path = to.path
    next({
      name: 'login',
    })
  } else {
    next()
  }
}
function guardLogin(to, from, next) {
  const isLoggedIn = store.getters.isLoggedIn
  if (isLoggedIn) {
    const path = to.path
    next({name: 'validator'})
  } else {
    next()
  }
}
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
